// src/context/ProjectContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/constants';
import { useAuth } from './AuthContext';

const ProjectContext = createContext();

export function ProjectProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [projects, setProjects] = useState([]);
  const [selectedProjectID, setSelectedProjectIDState] = useState(() => {
    return localStorage.getItem('selectedProjectID') || '1';
  });
  const [loadingProjects, setLoadingProjects] = useState(true);

  useEffect(() => {
    // Pokrećemo dohvat projekata tek kada smo sigurni da je korisnik ulogiran
    if (isAuthenticated === true) {
      const token = localStorage.getItem('token');
      setLoadingProjects(true);

      fetch(`${API_BASE_URL}/projectListForUser`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
        .then(res => {
          if (!res.ok) throw new Error('Greška pri dohvatu projekata');
          return res.json();
        })
        .then(data => {
          setProjects(data);
          
          // Ako imamo spremljen ID koji ne postoji u novoj listi, resetiramo na prvi dostupni projekt
          if (data.length > 0 && !data.some(p => String(p.projectID) === selectedProjectID)) {
            setSelectedProjectID(String(data[0].projectID));
          }
          setLoadingProjects(false);
        })
        .catch(err => {
          console.error("ProjectContext: Greška:", err);
          setLoadingProjects(false);
        });
    } else {
      setLoadingProjects(false);
    }
  }, [isAuthenticated]);

  // Omotnica za promjenu projekta koja ujedno ažurira i localStorage
  const setSelectedProjectID = (id) => {
    setSelectedProjectIDState(String(id));
    localStorage.setItem('selectedProjectID', String(id));
  };

  return (
    <ProjectContext.Provider value={{ projects, selectedProjectID, setSelectedProjectID, loadingProjects }}>
      {children}
    </ProjectContext.Provider>
  );
}

export function useProject() {
  return useContext(ProjectContext);
}